export class AuthModel {
  authToken: string;
  expiresIn: Date;

  setAuth(auth: AuthModel) {
    this.authToken = auth.authToken;
    this.expiresIn = auth.expiresIn;
  }
}
